import { useLocation, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import { PlusCircleFilled } from "@ant-design/icons";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import tick from "../../../imgs/across.png";
import trash from "../../../imgs/trash.png";
import across from "../../../imgs/across.png";
import cross from "../../../imgs/cross.png";
import check from "../../../imgs/add.png";
import img from "../../../imgs/impLogo.png";
import { detectObjectsInImage } from "../../../utlis/modelLoader";
import FaceVerificatioNModal from "../../../utlis/FaceVerficationLoaderModal";

import { message } from "antd";
let file;

const FifthB = () => {
  const token = useSelector((state) => state.token);
  const dataUser = useSelector((state) => state.dataUser);
  const benId = useSelector((state) => state.benId);
  const penId = useSelector((state) => state.penId);
  const popData = useSelector((state) => state.popData);
  const creatingBen = useSelector((state) => state.benCreate);
  const router = useNavigate();
  const [display, setDisplay] = useState("");
  const [display1, setDisplay1] = useState("");
  const [display2, setDisplay2] = useState("");
  const [display3, setDisplay3] = useState("");
  const [displayx, setDisplayx] = useState(
    "data:image/png;base64,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"
  );
  const [displayz, setDisplayz] = useState(
    "data:image/png;base64,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"
  );
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const [err, setErr] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();
  const dash = location.pathname;

  const [name1, setName1] = useState("");
  const [sig1, setSig1] = useState("");
  const [gov1, setGov1] = useState("");
  const [img1, setImg1] = useState("");

  const [name2, setName2] = useState("");
  const [sig2, setSig2] = useState("");
  const [prof1, setProf1] = useState("");
  const [prof2, setProf2] = useState("");
  const [gov2, setGov2] = useState("");
  const [img2, setImg2] = useState("");
  const [verify, setVerify] = useState(false);
  const [iShow, setIShow] = useState(false);
  const [iShow1, setIShow1] = useState(false);
  const [iShow2, setIShow2] = useState(false);
  const [iShow3, setIShow3] = useState(false);
  const [isLoadingz, setIsLoadingz] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoading1, setIsLoading1] = useState(false);
  const [isLoading2, setIsLoading2] = useState(false);
  const [isLoading3, setIsLoading3] = useState(false);
  const [isLoading4, setIsLoading4] = useState(false);
  const [checkk, setCheckk] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();
  const faceApi = useSelector((state) => state.faceApi);
  const [witness2Handler, setWitness2Handler] = useState("");
  const [previousImage, setPreviousImage] = useState("");
  const [notHuman, setNotHuman] = useState(false);
  const fileInputRef = useRef(null);
  console.log(isLoadingz, isLoading);
  const FaceError = () => {
    messageApi.open({
      // type: 'success',
      content: (
        <div style={{ display: "flex", alignItems: "center" }}>
          <img src={img} alt="mage" width="50" height="50" />
          <h3>
            Please upload your profile image again; it's not verified as a human
            face.
          </h3>
        </div>
      ),
      duration: 6,
    });
  };

  const calculateFileHash = async (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const buffer = e.target.result;
        const cryptoKey = await crypto.subtle.digest("SHA-256", buffer);
        const hashArray = Array.from(new Uint8Array(cryptoKey));
        const hashHex = hashArray
          .map((byte) => byte.toString(16).padStart(2, "0"))
          .join("");
        resolve(hashHex);
      };

      reader.onerror = (error) => {
        reject(error);
      };

      reader.readAsArrayBuffer(file);
    });
  };

  const imageHandler = (setState, setUrl, load, check) => async (e) => {
    if (check === "ww") {
      const file = e.target.files[0];
      const newImageHash = await calculateFileHash(file);

      if (newImageHash === previousImage && notHuman === true) {
        FaceError();
        fileInputRef.current.value = null;
        return;
      }

      if (file) {
        dispatch({ type: "FACE_API", num: true });
        const detectedObjects = await detectObjectsInImage(file);
        const hasHuman = detectedObjects.some(
          (object) => object.class === "person"
        );
        dispatch({ type: "FACE_API", num: false });
        if (hasHuman) {
          setNotHuman(false);
          imageUploder(e, setState, setUrl, load, check);
          console.log("The image contains a human.");
        } else {
          setNotHuman(true);
          setPreviousImage(newImageHash);
          FaceError();
          console.log("The image does not contain a human.");
        }
        fileInputRef.current.value = null;
      }
    } else {
      imageUploder(e, setState, setUrl, load, check);
    }
  };

  const imageUploder = async (e, setState, setUrl, load, check) => {
    // load(true);
    file = e.target.files[0];
    const base641 = await convertToBase64(file);
    setState(base641);
    var bodyFormData = new FormData();
    bodyFormData.append("file", file);
    if (check === "ww") {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/v1/file/images?fileType=profile`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((data) => {
          setUrl(data.data.url);
          load(false);
        })
        .catch(() => {});
    } else {
      axios({
        method: "post",
        url: `${process.env.REACT_APP_BASE_URL}/v1/file/images?fileType=document`,
        data: bodyFormData,
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      })
        .then((data) => {
          load(false);
          setUrl(data.data.url);
        })
        .catch(() => {});
    }
  };
  function convertToBase64(file) {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        resolve(fileReader.result);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  }

  const handleChange = (setState) => (event) => {
    setState(event.target.value);
  };

  const nextHandler = (e) => {
    e.preventDefault();
    if (
      name1 === "" &&
      sig1 === "" &&
      gov1 === "" &&
      img1 === "" &&
      name2 === "" &&
      sig2 === "" &&
      gov2 === "" &&
      img2 === "" &&
      prof1 === "" &&
      prof2 === ""
    ) {
      setVerify(true);
    } else {
      let body = [
        {
          name: `${name1}`,
          signature: `${sig1}`,
          govtID: `${gov1}`,
          image: `${prof1}`,
          govtIDFrontImg: `${img1}`,
        },
      ];
      if (name2 || sig2 !== "" || gov2 || img2 !== "") {
        const wit = {
          name: `${name2}`,
          signature: `${sig2}`,
          govtID: `${gov2}`,
          image: `${prof2}`,
          govtIDFrontImg: `${img2}`,
        };
        body.push(wit);
      }
      if (
        dash === "/EDashboard/BeneficiaryQuestions" ||
        dash === "/superAdminDashboard/BeneficiaryQuestions" ||
        dash === "/AdminDashboard/BeneficiaryQuestions"
      ) {
        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/witnesses/add-by-staff?beneficiaryUserId=${benId}&programId=${penId}`,
            { witnesses: body },
            {
              headers: {
                Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
              },
            }
          )
          .then(() => {
            if (dataUser?.data?.user?.roles[0] === "employee") {
              dispatch({ type: "SET", num: 0 });
              dispatch({ type: "BISET", num: 0 });
              dispatch({ type: "BRSET", num: 0 });
              if (creatingBen === "true") router("/EDashboard/listing");
              else router("/EDashboard/allApplications");
            } else if (dataUser?.data?.user?.roles[0] === "superadmin") {
              dispatch({ type: "SET", num: 0 });
              dispatch({ type: "BISET", num: 0 });
              dispatch({ type: "BRSET", num: 0 });
              if (creatingBen === "true")
                router("/superAdminDashboard/listing");
              else router("/superAdminDashboard/allApplications");
            } else if (dataUser?.data?.user?.roles[0] === "admin") {
              dispatch({ type: "SET", num: 0 });
              dispatch({ type: "BISET", num: 0 });
              dispatch({ type: "BRSET", num: 0 });
              if (creatingBen === "true") router("/AdminDashboard/listing");
              else router("/AdminDashboard/allApplications");
            } else {
              axios
                .get(
                  `${process.env.REACT_APP_BASE_URL}/v1/users/pensioner-profile/${popData.id}`,
                  {
                    headers: {
                      Authorization: `Bearer ${dataUser.data.tokens.access.token}`,
                    },
                  }
                )
                .then((data) => {
                  router("/EDashboard/application");
                  dispatch({ type: "setProfileData", num: data.data });
                  dispatch({ type: "universalPenSet", num: data.data.user.id });
                  dispatch({ type: "pensionerId", num: data.data.user.id });
                  setTimeout(() => {
                    dispatch({ type: "SET", num: 0 });
                    dispatch({ type: "BISET", num: 0 });
                    dispatch({ type: "BRSET", num: 0 });
                  }, 5000);
                })
                .catch(() => {})
                .catch((err) => {
                  if (
                    err.response.data.message ===
                    `"govtID" is not allowed to be empty`
                  )
                    setErr("Please enter Government ID.");
                  else setErr(err.response.data.message);
                  setShow(true);
                });
            }
          })
          .catch((err) => {
            if (
              err.response.data.message ===
              `"govtID" is not allowed to be empty`
            )
              setErr("Please enter Government ID.");
            else setErr(err.response.data.message);
            setShow(true);
          });
      } else {
        // https://oap-api-staging.jabcomp.gy/v1/witnesses/${benId}?programId=${penId}

        axios
          .post(
            `${process.env.REACT_APP_BASE_URL}/v1/witnesses?beneficiaryUserId=${benId}&programId=${penId}`,
            body,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          )
          .then(() => {
            if (dash === "/Dashboard/BeneficiaryQuestions") {
              dispatch({ type: "SET", num: 0 });
              dispatch({ type: "BISET", num: 0 });
              dispatch({ type: "BRSET", num: 0 });
              router("/Dashboard/listing");
            } else {
              // setShow1(true);
              dispatch({ type: "ISET", num: 9 });
            }
          })
          .catch((err) => {
            if (
              err.response.data.message ===
              `"govtID" is not allowed to be empty`
            )
              setErr("Please enter Government ID.");
            else setErr(err.response.data.message);
            setShow(true);
          });
      }
    }
  };
  useEffect(() => {
    if (
      name1 !== "" &&
      sig1 !== "" &&
      gov1 !== "" &&
      img1 !== "" &&
      prof1 !== ""
    )
      setCheckk(false);
    else setCheckk(true);
  }, [name1, sig1, gov1, img1, prof1]);
  return (
    <div>
      {contextHolder}
      <form onSubmit={nextHandler} className=" mt-10">
        <div className="flex justify-center items-center">
          <div className="grid-cols-1 sm:w-[60%] w-[70%]">
            <div>
              <div className="flex items-center justify-center mb-4">
                <label
                  htmlFor="special-inputd"
                  className="cursor-pointer relative"
                >
                  <div className="relative w-[6.5rem] h-[6.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
                    <img
                      className="object-cover w-[6.5rem] h-[6.5rem]"
                      src={displayx}
                      alt=""
                    />
                    {/* <div
                      className={`${
                        isLoading ? "" : "hidden"
                      } w-[6.5rem] h-[6.5rem] rounded-full absolute top-0 bg-[#686262] bg-opacity-70  flex justify-center items-center`}
                    >
                      <Spin indicator={antIcon} />
                    </div> */}
                  </div>

                  <div
                    className={`bg-primary rounded-full absolute bottom-4 right-2`}
                  >
                    <img src={check} className="lg:w-6 w-5" alt="" />
                  </div>
                  <input
                    type="file"
                    className="hidden"
                    id="special-inputd"
                    accept="image/png, image/gif, image/jpeg"
                    onInput={imageHandler(
                      setDisplayx,
                      setProf1,
                      setIsLoading,
                      "ww"
                    )}
                    ref={fileInputRef}
                  />
                </label>
              </div>
              <h2
                htmlFor="input2"
                className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
              >
                Witness 1 Name *
              </h2>
              <input
                type="text"
                name=""
                placeholder="Name"
                onChange={handleChange(setName1)}
                value={name1}
                className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
              />
              <h2
                htmlFor="input2"
                className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
              >
                Signature *
              </h2>
              <label
                htmlFor="special-input"
                className={`${
                  isLoading1 || isLoading2 || isLoading3 || isLoading4
                    ? "pointer-events-none"
                    : ""
                } cursor-pointer relative`}
              >
                <div className="lg:mb-5 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                  <div>
                    <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                  </div>
                  <p className="text-[#9CA6C2] ml-2">Signature</p>
                </div>
                <input
                  type="file"
                  className="hidden"
                  id="special-input"
                  accept="image/png, image/gif, image/jpeg"
                  onInput={imageHandler(setDisplay, setSig1, setIsLoading1)}
                />
              </label>
              <div
                className={`relative flex items-center justify-center bg-[#FAF9F6] mb-4 ${
                  display ? "" : "hidden"
                }`}
              >
                <img
                  onClick={() => {
                    setIShow(true);
                  }}
                  className="w-[25rem] h-[13rem]"
                  src={display}
                  alt=""
                />
                <div
                  className="absolute bottom-0 right-0 bg-white cursor-pointer"
                  onClick={() => {
                    const wow = document.getElementById("special-input");
                    wow.value = "";
                    setDisplay("");
                    setSig1("");
                    setIsLoading1(false);
                    setIsLoading2(false);
                    setIsLoading3(false);
                    setIsLoading4(false);
                  }}
                >
                  <img className="sm:w-[3rem] w-[2rem]" src={trash} alt="" />
                </div>
              </div>
              <div
                className={`${
                  iShow ? "" : "hidden"
                } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-[100]`}
              >
                <div className="relative rounded-xl flex items-center p-8 bg-white flex-col">
                  <img
                    className="scale-[0.7] absolute top-2 right-2 cursor-pointer"
                    src={cross}
                    onClick={() => setIShow(false)}
                    alt=""
                  />
                  <img className="w-[45rem] h-[28rem]" src={display} alt="" />
                </div>
              </div>
              <h2
                htmlFor="input2"
                className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
              >
                Government ID # *
              </h2>
              <input
                type="text"
                name=""
                placeholder="Government ID #"
                onChange={handleChange(setGov1)}
                value={gov1}
                className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
              />
              <h2
                htmlFor="input2"
                className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
              >
                Front Image *
              </h2>
              <label
                htmlFor="special-input1"
                className={`${
                  isLoading1 || isLoading2 || isLoading3 || isLoading4
                    ? "pointer-events-none"
                    : ""
                } cursor-pointer relative`}
              >
                <div className="lg:mb-5 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                  <div>
                    <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                  </div>
                  <p className="text-[#9CA6C2] ml-2">Front Image</p>
                </div>
                <input
                  type="file"
                  className="hidden"
                  id="special-input1"
                  accept="image/png, image/gif, image/jpeg"
                  onInput={imageHandler(setDisplay1, setImg1, setIsLoading2)}
                />
              </label>
              <div
                className={`relative flex items-center justify-center bg-[#FAF9F6] mb-4 ${
                  display1 ? "" : "hidden"
                }`}
              >
                <img
                  onClick={() => {
                    setIShow1(true);
                  }}
                  className="w-[25rem] h-[13rem]"
                  src={display1}
                  alt=""
                />
                <div
                  className="absolute bottom-0 right-0 bg-white cursor-pointer"
                  onClick={() => {
                    const wow = document.getElementById("special-input1");
                    wow.value = "";
                    setDisplay1("");
                    setImg1("");
                    setIsLoading1(false);
                    setIsLoading2(false);
                    setIsLoading3(false);
                    setIsLoading4(false);
                  }}
                >
                  <img className="sm:w-[3rem] w-[2rem]" src={trash} alt="" />
                </div>
              </div>
            </div>
            <div
              className={`${
                iShow1 ? "" : "hidden"
              } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-[100]`}
            >
              <div className="relative rounded-xl flex items-center p-8 bg-white flex-col">
                <img
                  className="scale-[0.7] absolute top-2 right-2 cursor-pointer"
                  src={cross}
                  onClick={() => setIShow1(false)}
                  alt=""
                />
                <img className="w-[45rem] h-[28rem]" src={display1} alt="" />
              </div>
            </div>
            {checkk === false && witness2Handler !== "add" && (
              <div
                className="flex justify-center items-center mt-[6rem]"
                onClick={() => setWitness2Handler("add")}
              >
                <div className="flex justify-center items-center cursor-pointer">
                  <div>
                    <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center mr-2" />
                  </div>
                  <p className="text-primary">Add Another Witness</p>
                </div>
              </div>
            )}
            {
              <div
                className={`flex justify-end cursor-pointer mt-[6rem] ${
                  witness2Handler === "add" ? "" : "hidden"
                }`}
                onClick={() => {
                  const wow = document.getElementById("special-input3");
                  wow.value = "";
                  setImg2("");
                  setDisplay3("");
                  setDisplay2("");
                  setSig2("");
                  const wow1 = document.getElementById("special-input2");
                  wow1.value = "";
                  setProf2(null);
                  setName2("");
                  setGov2("");
                  setWitness2Handler("");
                }}
              >
                <p className="text-[red] underline text-[0.94rem]">
                  Remove Witness 2
                </p>
              </div>
            }
            {witness2Handler === "add" && (
              <div>
                <div className="flex items-center justify-center mb-4">
                  <label
                    htmlFor="special-input8"
                    className="cursor-pointer relative"
                  >
                    <div className="relative w-[6.5rem] h-[6.5rem] overflow-hidden border-2 border-[#686262]  rounded-full mb-4 ">
                      <img
                        className="object-cover w-[6.5rem] h-[6.5rem]"
                        src={displayz}
                        alt=""
                      />
                    </div>

                    <div
                      className={`bg-primary rounded-full absolute bottom-4 right-2`}
                    >
                      <img src={check} className="lg:w-6 w-5" alt="" />
                    </div>
                    <input
                      disabled={checkk}
                      type="file"
                      className="hidden"
                      id="special-input8"
                      accept="image/png, image/gif, image/jpeg"
                      onInput={imageHandler(
                        setDisplayz,
                        setProf2,
                        setIsLoadingz,
                        "ww"
                      )}
                      ref={fileInputRef}
                    />
                  </label>
                </div>
                <h2
                  htmlFor="input2"
                  className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                >
                  Witness 2 Name
                </h2>
                <input
                  disabled={checkk}
                  type="text"
                  name=""
                  placeholder="Name"
                  onChange={handleChange(setName2)}
                  value={name2}
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
                <h2
                  htmlFor="input2"
                  className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                >
                  Signature
                </h2>
                <label
                  htmlFor="special-input2"
                  className={`${
                    isLoading1 || isLoading2 || isLoading3 || isLoading4
                      ? "pointer-events-none"
                      : ""
                  } cursor-pointer relative`}
                >
                  <div className="lg:mb-5 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                    <div>
                      <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                    </div>
                    <p className="text-[#9CA6C2] ml-2">Signature</p>
                  </div>
                  <input
                    disabled={checkk}
                    type="file"
                    className="hidden"
                    id="special-input2"
                    accept="image/png, image/gif, image/jpeg"
                    onInput={imageHandler(setDisplay2, setSig2, setIsLoading3)}
                  />
                </label>
                <div
                  className={`relative flex items-center justify-center bg-[#FAF9F6] mb-4 ${
                    display2 ? "" : "hidden"
                  }`}
                >
                  <img
                    onClick={() => {
                      setIShow2(true);
                    }}
                    className="w-[25rem] h-[13rem]"
                    src={display2}
                    alt=""
                  />
                  <div
                    className="absolute bottom-0 right-0 bg-white cursor-pointer"
                    onClick={() => {
                      setDisplay2("");
                      setSig2("");
                      const wow = document.getElementById("special-input2");
                      wow.value = "";
                    }}
                  >
                    <img className="sm:w-[3rem] w-[2rem]" src={trash} alt="" />
                  </div>
                </div>
                <div
                  className={`${
                    iShow2 ? "" : "hidden"
                  } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-[100]`}
                >
                  <div className="relative rounded-xl flex items-center p-8 bg-white flex-col">
                    <img
                      className="scale-[0.7] absolute top-2 right-2 cursor-pointer"
                      src={cross}
                      onClick={() => setIShow2(false)}
                      alt=""
                    />
                    <img
                      className="w-[45rem] h-[28rem]"
                      src={display2}
                      alt=""
                    />
                  </div>
                </div>
                <h2
                  htmlFor="input2"
                  className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                >
                  Government ID #
                </h2>
                <input
                  disabled={checkk}
                  type="text"
                  name=""
                  placeholder="Government ID #"
                  onChange={handleChange(setGov2)}
                  value={gov2}
                  className=" lg:text-[1.1rem] w-[100%] bg-white border-[1px] border-[#C6CFE5] rounded-[0.3rem] p-2 mb-4"
                />
                <h2
                  htmlFor="input2"
                  className="text-[#596F96] text-[0.88rem] font-semibold mb-2"
                >
                  Front Image
                </h2>
                <label
                  htmlFor="special-input3"
                  className={`${
                    isLoading1 || isLoading2 || isLoading3 || isLoading4
                      ? "pointer-events-none"
                      : ""
                  } cursor-pointer relative`}
                >
                  <div className="lg:mb-5 lg:text-[1.1rem] w-[100%] bg-[white] border-[1px] border-[#c6cfe5] rounded-[0.5rem] p-2 mb-4 flex items-center">
                    <div>
                      <PlusCircleFilled className="text-primary text-2xl flex items-center justify-center" />
                    </div>
                    <p className="text-[#9CA6C2] ml-2">Front Image</p>
                  </div>
                  <input
                    disabled={checkk}
                    type="file"
                    className="hidden"
                    id="special-input3"
                    accept="image/png, image/gif, image/jpeg"
                    onInput={imageHandler(setDisplay3, setImg2, setIsLoading4)}
                  />
                </label>
                <div
                  className={`relative flex items-center justify-center bg-[#FAF9F6] mb-4 ${
                    display3 ? "" : "hidden"
                  }`}
                >
                  <img
                    onClick={() => {
                      setIShow3(true);
                    }}
                    className="w-[25rem] h-[13rem]"
                    src={display3}
                    alt=""
                  />
                  <div
                    className="absolute bottom-0 right-0 bg-white cursor-pointer"
                    onClick={() => {
                      const wow = document.getElementById("special-input3");
                      wow.value = "";
                      setImg2("");
                      setDisplay3("");
                    }}
                  >
                    <img className="sm:w-[3rem] w-[2rem]" src={trash} alt="" />
                  </div>
                </div>
                <div
                  className={`${
                    iShow3 ? "" : "hidden"
                  } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center z-[100]`}
                >
                  <div className="relative rounded-xl flex items-center p-8 bg-white flex-col">
                    <img
                      className="scale-[0.7] absolute top-2 right-2 cursor-pointer"
                      src={cross}
                      onClick={() => setIShow3(false)}
                      alt=""
                    />
                    <img
                      className="w-[45rem] h-[28rem]"
                      src={display3}
                      alt=""
                    />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        <div
          className={`lg:mt-[3rem] flex mt-4 items-center sm:justify-end justify-center sm:w-[85%]`}
        >
          {/* <button
            type="button"
            onClick={() => dispatch({ type: "IDECREMENT" })}
            className={`lg:text-[1.1rem] bg-[#F2F4F8] text-black rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Back
          </button> */}
          <button
            type="submit"
            // onClick={() => dispatch({ type: "ISET", num: 9 })}
            className={`lg:text-[1.1rem] bg-gradient-to-tr ml-4 bg-primary text-white rounded-[0.5rem] p-2  pr-8 pl-8`}
          >
            Done
          </button>
        </div>
      </form>

      <div
        className={`${
          verify ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setVerify(false)}
          >
            <img src={tick} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">
            Please enter information for at least Witness 1
          </p>

          <button
            type="submit"
            onClick={() => setVerify(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          show ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <div
            className="absolute top-[-11%] left-[42%]"
            onClick={() => setShow(false)}
          >
            <img src={across} alt="" />
          </div>
          <p className="text-center mt-[3rem] mb-5">{err}</p>
          <button
            onClick={() => setShow(false)}
            className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
          >
            Ok
          </button>
        </div>
      </div>
      <div
        className={`${
          show1 ? "" : "hidden"
        } w-[100%] h-[100%] fixed top-0 left-0 bg-slate-500/50 flex justify-center items-center`}
      >
        <div className="relative rounded-xl w-[20rem] pb-6 flex items-center p-3 bg-white flex-col">
          <p className="text-center mt-[3rem] mb-5">
            Do you want to mark this Beneficiary as Default?
          </p>
          <div className="flex">
            <button
              onClick={() => {
                setShow1(false);
                dispatch({ type: "ISET", num: 9 });
              }}
              className="cursor-pointer rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-[#DE2827] w-[60%]"
            >
              Skip
            </button>
            <button
              onClick={() => {
                axios
                  .post(
                    `${process.env.REACT_APP_BASE_URL}/v1/beneficiary-info/default/toggle?beneficiaryUserId=${benId}`,
                    {
                      programId: `${penId}`,
                      isDefault: true,
                    },
                    {
                      headers: {
                        Authorization: `Bearer ${token}`,
                      },
                    }
                  )
                  .then((data) => {
                    setShow1(false);
                    dispatch({ type: "ISET", num: 10 });
                    dispatch({ type: "POP" });
                  })
                  .catch((err) => {});
              }}
              className="cursor-pointer ml-2 rounded-xl pt-[0.5rem] pb-[0.5rem] pl-10 pr-10 text-white bg-primary w-[60%]"
            >
              Default
            </button>
          </div>
        </div>
      </div>
      {faceApi === true && <FaceVerificatioNModal />}
    </div>
  );
};

export default FifthB;
